import { Attribute } from '../types/Customer';

const getAttributeValue = (attributes: Attribute[], code: string): string => {
  if (attributes.length === 0) return '';

  const attribute = attributes.find((a) => a.code === code);
  return attribute ? attribute.value : '';
};

const getAttributeValues = (
  attributes: Attribute[],
  code: string
): string[] => {
  if (attributes.length === 0) return [];

  return attributes.filter((a) => a.code === code).map((a) => a.value);
};

export { getAttributeValue, getAttributeValues };
